if (!customElements.get('maerelle-cart-rewards')) {
  let previousFill;
  let previousCount;
  customElements.define('maerelle-cart-rewards', class extends HTMLElement {
    connectedCallback() {
      const line = this.querySelector('.me-cart-rewards__track > span');
      const steps = [...this.querySelectorAll('.me-cart-rewards__steps li')];
      const dots = steps.map(step => step.querySelector('.me-cart-rewards__dot'));
      if (!line) return;
      const target = Number(this.dataset.fill);
      const count = Number(this.dataset.count);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = reduced ? target : (previousFill ?? target);
      const startCount = reduced ? count : (previousCount ?? count);
      previousFill = target;
      previousCount = count;
      const setSteps = value => {
        steps.forEach((step, i) => step.classList.toggle('is-reached', value >= i + 2));
        this.classList.toggle('is-complete', value >= 5);
      };
      line.style.transition = 'none';
      dots.forEach(dot => { if (dot) dot.style.transition = 'none'; });
      line.style.width = start + '%';
      setSteps(startCount);
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        line.getBoundingClientRect();
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const timing = '700ms cubic-bezier(.22,1,.36,1)';
          line.style.transition = reduced ? 'none' : 'width ' + timing;
          dots.forEach(dot => {
            if (dot) dot.style.transition = reduced ? 'none' : 'background-color ' + timing + ', color ' + timing;
          });
          line.style.width = target + '%';
          setSteps(count);
        });
      });
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); }
  });
}
